export const common = {
  processing: 'We are processing your request...',
  defaultErrorTitle: 'Something went wrong',
  defaultRetryButton: 'Try Again',
  weightInputAriaLabel: 'Weight in pounds',
  heightFeetAriaLabel: 'Height in feet',
  heightInchesAriaLabel: 'Height in inches',
  goToHome: 'Go to Home',
};

export const iframe = {
  updatePaymentMethod: 'Update Payment Method',
  payment: 'Payment',
};

export const wallet = {
  errors: {
    notSupported: 'Wallet not supported on this platform',
    downloadFailed: 'Failed to download wallet pass',
    appleWalletFailed: 'Failed to add to Apple Wallet',
    googleWalletFailed: 'Failed to add to Google Wallet',
  },
};
